import { render, staticRenderFns } from "./ServiceTypeAddEdit.vue?vue&type=template&id=258d933a"
import script from "./ServiceTypeAddEdit.vue?vue&type=script&lang=js"
export * from "./ServiceTypeAddEdit.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeAddEdit.vue?vue&type=style&index=0&id=258d933a&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports